import axios from "axios";

const getModuleDropdown = async search => {
    const body = search

    const response = await axios.get('/campaign/api/admin/campaign-products', { params: body });

    return response.data;
};

export default getModuleDropdown;